import Vue from 'vue'
import App from '@/App'
import '@/utils/polyfills'

// Vue
import router from '@/router/'
import store from '@/store/'

// Plugins
import { Plugin } from 'vue-fragment'
import i18n from './plugins/i18n'
import '@/plugins/wsefy'
import '@/plugins/sentry'
import '@/plugins/vee-validate'

import '@/components/icons'

import '@/plugins/vue-mask'
import '@/plugins/axios'
import '@/plugins/nprogress'
import '@/plugins/buefy'
import '@/plugins/moment'
import '@/plugins/svgicon'
import '@/plugins/tooltip'
// Helpers
import '@/directives/click-outside'

// Styles
import '@/assets/scss/app.scss'

// PWA
// import '@/plugins/registerServiceWorker'
import '@/components'

Vue.config.productionTip = __stage === 'prod'
Vue.use(Plugin)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
